import { faArrowRotateBack } from '@fortawesome/pro-light-svg-icons'
import { useCallback } from 'react'
import { DropdownVerticalSortItem } from '../../../../../baseComponents/Sorts/DropdownVerticalSortList/types'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import Checkbox from '../../../../../forms/Checkbox'
import ModalTaskConfigColumnsFiltersComponentsRenderer from './ModalTaskConfigColumnsFiltersComponents'
import DropdownVerticalSortList from '../../../../../baseComponents/Sorts/DropdownVerticalSortList'
import TwinForm from '../../../../../forms/TwinForm'
import { ModalCreateEditStructureLayout } from '../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import HeaderModalTaskConfigColumns from '../HeaderModalTaskConfigColumns'
import TwinTrans from '../../../../../baseComponents/TwinTrans'
import TwinIcon from '../../../../../baseComponents/TwinIcon'
import { ModalTaskConfigColumnsBaseProps } from '../types'
import { TwinDictionary } from '../../../../../utils/globals/dictionary'
import { SelectedTaskColsFiltersHeader } from '../../../../../utils/hooks/tasks/useTaskConfigColumns'

interface ModalTaskConfigColumnsFiltersProps extends ModalTaskConfigColumnsFiltersLogicProps {
}

const ModalTaskConfigColumnsFilters: React.FC<ModalTaskConfigColumnsFiltersProps> = ({ tmpColumns, columns, onSave, ...logic }) => {
    const { changeChecked, changeOrder, resetSelected, changeSingleField } = useModalTaskConfigColumnsFiltersLogic({ tmpColumns, columns, onSave, ...logic })
    const { t } = useTwinTranslation()

    const firstColumn: JSX.Element[] = []
    const secondColumn: DropdownVerticalSortItem[] = []
    const premiumColumns: JSX.Element[] = []
    for (const key in columns) {
        const item = columns[key]
        if ((item.label || item.simpleLabel) && item.havePermission !== false && item.searchableComponent) {
            if (item.haveModule !== false) {
                const index = Object.keys(tmpColumns.filters).indexOf(item.id)
                const selected = index !== -1
                firstColumn.push(<div className='mt-15' key={key}><Checkbox label={item.simpleLabel || item.label as any} onChange={() => changeChecked(item.id)} checked={selected} /></div>)
                if (selected) {
                    secondColumn.push({
                        name: item.simpleLabel || item.label as any,
                        id: item.id,
                        order: index + 1,
                        component: <ModalTaskConfigColumnsFiltersComponentsRenderer changeSingleField={changeSingleField} {...item} value={tmpColumns.filters[item.id]} component={item.searchableComponent.component} extraComponentData={item.searchableComponent.extraComponentData} />
                    })
                }
            } else {
                premiumColumns.push(<div className='mt-15' key={key}><Checkbox label={item.simpleLabel || item.label as any} onChange={() => changeChecked(item.id)} checked={true} readOnly={true} /></div>)
            }
        }
    }
    secondColumn.sort((a, b) => a.order - b.order)
    if (secondColumn[secondColumn.length - 1]) {
        secondColumn[secondColumn.length - 1].component = (<ModalTaskConfigColumnsFiltersComponentsRenderer {...secondColumn[secondColumn.length - 1].component.props} isLast={true} />)        
    }
    let secondColumnRender: JSX.Element | null = <DropdownVerticalSortList items={secondColumn} setItems={(setItemsFake) => changeOrder(setItemsFake(secondColumn))} />
    if (!secondColumn.length) {
        secondColumnRender = <NoFilters />
    }
    return (
        <TwinForm beforeSubmitHandler={onSave} className='flex flex-col flex-auto'>
            <ModalCreateEditStructureLayout loading={false} translations={{
                title: <HeaderModalTaskConfigColumns {...{ tmpColumns, columns, setTmpColumns: logic.setTmpColumns, name: logic.name, headers: logic.headers }} />,
                button: t('save', 'Guardar')
            }} haveButtonPermissions={true} className='modal_negative_margin'>
                <div className='overflow-auto h-full w-full'>
                    <div className='flex flex-wrap w-full h-full config_columns_container'>
                        <div className='w-fit max-w-300'>
                            <div className='flex flex-wrap items-center mb-20'>
                                <h4 className='mr-18 '><TwinTrans transKey='filtersToShow'>Mostrar filtros</TwinTrans></h4>
                                <div className='flex items-center text-green-21 cursor-pointer' onClick={resetSelected}>
                                    <TwinIcon icon={faArrowRotateBack} fontSize={14} className='mr-8' />
                                    <span className='mt-2 lh-14'><TwinTrans transKey='uncheckAll'>Desmarcar todo</TwinTrans></span>
                                </div>
                            </div>
                            {firstColumn}
                            {premiumColumns.length ? <div className='mt-20'>
                                <h2><TwinTrans transKey='columnsCouldBuy'>Columnas que podrías comprar</TwinTrans></h2>
                                {premiumColumns}
                            </div> : null}
                        </div>
                        <div className='border-r border-gray-D6 w-1 mx-35 config_columns_border' ></div>
                        <div className='flex flex-col min-h-full flex-auto w-1 config_colums_sort_list'>
                            <h4 className='mb-20'><TwinTrans transKey='orderAndConfigureSelectedFilters'>Ordena y configura los filtros seleccionados</TwinTrans></h4>
                            {secondColumnRender}
                        </div>
                    </div>
                </div>
            </ModalCreateEditStructureLayout>
        </TwinForm>
    )
}

interface ModalTaskConfigColumnsFiltersLogicProps extends ModalTaskConfigColumnsBaseProps { }

const useModalTaskConfigColumnsFiltersLogic = ({ setTmpColumns }: ModalTaskConfigColumnsFiltersLogicProps) => {
    const changeChecked = useCallback((itemKey: string) => {
        setTmpColumns((oldTmp: SelectedTaskColsFiltersHeader) => {
            let tmpCopy: SelectedTaskColsFiltersHeader = JSON.parse(JSON.stringify(oldTmp))
            const item = tmpCopy.filters[itemKey]
            if (item) {
                delete tmpCopy.filters[itemKey]
            } else {
                tmpCopy.filters = { ...tmpCopy.filters, [itemKey]: {} }
            }
            return { ...tmpCopy }
        })
    }, [setTmpColumns])

    const changeOrder = useCallback((items: DropdownVerticalSortItem[]) => {
        setTmpColumns((oldTmp: SelectedTaskColsFiltersHeader) => {
            const copy: SelectedTaskColsFiltersHeader = JSON.parse(JSON.stringify(oldTmp))
            let filters: SelectedTaskColsFiltersHeader['filters'] = {}
            for (const item of items) {
                filters[item.id] = copy.filters[item.id] || {}
            }
            return { ...copy, filters }
        })
    }, [setTmpColumns])

    const resetSelected = useCallback(() => {
        setTmpColumns((oldTmp: SelectedTaskColsFiltersHeader) => {
            const copy: SelectedTaskColsFiltersHeader = JSON.parse(JSON.stringify(oldTmp))
            const myColumns = { ...copy, filters: {} }
            return myColumns
        })
    }, [setTmpColumns])

    const changeSingleField = useCallback((id: string, value: TwinDictionary) => {
        setTmpColumns((oldTmp: SelectedTaskColsFiltersHeader) => {
            const copy: SelectedTaskColsFiltersHeader = JSON.parse(JSON.stringify(oldTmp))
            const myColumns = { ...copy, filters: { ...copy.filters, [id]: value } }
            return myColumns
        })
    }, [setTmpColumns])

    return { setTmpColumns, changeChecked, changeOrder, resetSelected, changeSingleField }
}

interface NoFiltersProps {}

const NoFilters: React.FC<NoFiltersProps> = () => {
    return (
        <div className='no_filters flex flex-col items-center'>
            <img src='/ilustracion-filtros.svg' alt='' />
            <span className='light20'><TwinTrans transKey='alreadyYouDontAddFilters'>Todavía no has añadido ningún filtro</TwinTrans></span>
        </div>
    )
}


export default ModalTaskConfigColumnsFilters